import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[homeownerBlockSpecialChars]'
})
export class HomeownerBlockSpecialCharsDirective {
  // Block: < > [ ] / @
  private readonly forbidden = /[<>\[\]\/@]/g;

  constructor(private readonly el: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {
 
}
  private emitInputEvent(target: HTMLInputElement | HTMLTextAreaElement): void {
    target.dispatchEvent(new Event('input', { bubbles: true }));
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): void {
    if (
      e.key === '<' ||
      e.key === '>' ||
      e.key === '[' ||
      e.key === ']' ||
      e.key === '/' ||
      e.key === '@'
    ) {
      e.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(e: ClipboardEvent): void {
    const target = this.el.nativeElement;
    const pasted = e.clipboardData?.getData('text') ?? '';
    const cleaned = pasted.replace(this.forbidden, '');

    if (cleaned === pasted) return;

    e.preventDefault();

    const value = target.value ?? '';
    const start =
      typeof target.selectionStart === 'number'
        ? target.selectionStart
        : value.length;
    const end =
      typeof target.selectionEnd === 'number'
        ? target.selectionEnd
        : value.length;

    try {
      target.setRangeText(cleaned, start, end, 'end');
    } catch {
      target.value = value.slice(0, start) + cleaned + value.slice(end);
      try {
        const caret = start + cleaned.length;
        target.setSelectionRange(caret, caret);
      } catch {
        // ignore
      }
    }

    this.emitInputEvent(target);
  }

  @HostListener('input')
  onInput(): void {
    const target = this.el.nativeElement;
    const cleaned = (target.value ?? '').replace(this.forbidden, '');

    if (cleaned === target.value) return;

    const start =
      typeof target.selectionStart === 'number'
        ? target.selectionStart
        : cleaned.length;
    const end =
      typeof target.selectionEnd === 'number'
        ? target.selectionEnd
        : cleaned.length;

    target.value = cleaned;

    try {
      target.setSelectionRange(
        Math.min(start, cleaned.length),
        Math.min(end, cleaned.length)
      );
    } catch {
      // ignore
    }

    this.emitInputEvent(target);
  }
}
